import { saveAs } from 'file-saver';

function addColspan(count: number) {
  let col = '';
  for (let i = 0; i < count - 1; i++) {
    col += ',';
  }
  return col;
}
function checkCommas(innerText: string) {
  if (innerText.includes(',')) {
    return `"${innerText}",`;
  }
  return `${innerText},`;
}
export function downloadCSV(rows, filename: string) {
  let csv = '';
  for (let a = 0; a < rows.length; a++) {
    for (let t = 0; t < rows[a].children.length; t++) {
      if (rows[a].children[t].nodeName === 'THEAD') {
        const thead = rows[a].children[t].children[0];
        for (let i = 0; i < thead.children.length; i++) {
          csv += checkCommas(thead.children[i].innerText);
        }
        csv = `${csv.substring(0, csv.length - 1)}\n`;
      }
      if (rows[a].children[t].nodeName === 'TBODY') {
        const tbody = rows[a].children[t];

        for (let i = 0; i < tbody.children.length; i++) {
          for (let j = 0; j < tbody.children[i].children.length; j++) {
            csv += checkCommas(tbody.children[i].children[j].innerText);

            if (tbody.children[i].children[j].colSpan > 1) {
              csv += addColspan(tbody.children[i].children[j].colSpan);
            }
          }
          csv = `${csv.substring(0, csv.length - 1)}\n`;
        }
      }
    }
    csv += '\n\n';
  }
  const data: Blob = new Blob([csv], {
    type: 'text/csv;charset=utf-8',
  });

  saveAs(data, filename);
}
